import { TbPlus } from "react-icons/tb";

const HeaderTarifs = ({ openDrawer }) => {
  return (
    <div className="flex items-start justify-between pb-6 border-b border-gray-100">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Tarifs</h1>
        <p className="text-sm text-gray-400 mt-1">
          Gérez vos plans tarifaires et configurez les prix par période
        </p>
      </div>
      <button
        onClick={openDrawer}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--k-green)] hover:bg-[var(--k-green-hover)] text-white text-sm font-semibold rounded-xl transition-all duration-200 active:scale-[0.97] shadow-sm hover:shadow-md"
      >
        <TbPlus className="text-base" strokeWidth={2.5} />
        Créer un tarif
      </button>
    </div>
  );
};

export default HeaderTarifs;